import { Component } from '@angular/core';

@Component({
  selector: 'app-orari-institutional-session24',
  templateUrl: './orari-institutional-session24.component.html',
  styleUrl: '../../../../../../../styles-tabelle-orari.css'
})
export class OrariInstitutionalSession24Component {

}
